'use client';

import { c as _c } from "react/compiler-runtime";
import { CheckIcon, ChevronDownIcon, ChevronUpIcon, SearchIcon } from 'lucide-react';
import { useEffect, useState } from 'react';
interface Option {
  label: string;
  value: string;
}
interface Props {
  options: Option[];
  onSelect: (option: Option | null) => void;
  placeholder?: string;
  disabled?: boolean;
  width?: number;
  isSearch?: boolean;
  onSearch?: (term: string) => void;
  selectedValue?: string | null;
  size?: 'default' | 'sm';
}
const Dropdown = t0 => {
  const $ = _c(42);
  const {
    options,
    onSelect,
    placeholder: t1,
    disabled: t2,
    width,
    isSearch: t3,
    onSearch,
    selectedValue,
    size: t4
  } = t0;
  const placeholder = t1 === undefined ? "Select an option" : t1;
  const disabled = t2 === undefined ? false : t2;
  const isSearch = t3 === undefined ? false : t3;
  const size = t4 === undefined ? "default" : t4;
  const sm = size === "sm";
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredOptions, setFilteredOptions] = useState(options);
  let t5;
  let t6;
  if ($[0] !== options || $[1] !== selectedValue) {
    t5 = () => {
      if (selectedValue !== undefined) {
        const option = options.find(opt => opt.value === selectedValue) || null;
        setSelected(option);
      }
    };
    t6 = [selectedValue, options];
    $[0] = options;
    $[1] = selectedValue;
    $[2] = t5;
    $[3] = t6;
  } else {
    t5 = $[2];
    t6 = $[3];
  }
  useEffect(t5, t6);
  let t7;
  let t8;
  if ($[4] !== disabled || $[5] !== onSelect || $[6] !== selected) {
    t7 = () => {
      if (disabled && selected !== null) {
        setSelected(null);
        onSelect(null);
      }
    };
    t8 = [disabled, selected, onSelect];
    $[4] = disabled;
    $[5] = onSelect;
    $[6] = selected;
    $[7] = t7;
    $[8] = t8;
  } else {
    t7 = $[7];
    t8 = $[8];
  }
  useEffect(t7, t8);
  let t10;
  let t9;
  if ($[9] !== onSearch || $[10] !== options || $[11] !== searchTerm) {
    t9 = () => {
      if (onSearch) {
        onSearch(searchTerm);
        setFilteredOptions(options);
      } else {
        if (searchTerm) {
          setFilteredOptions(options.filter(option_0 => option_0.label.toLowerCase().includes(searchTerm.toLowerCase())));
        } else {
          setFilteredOptions(options);
        }
      }
    };
    t10 = [options, searchTerm, onSearch];
    $[9] = onSearch;
    $[10] = options;
    $[11] = searchTerm;
    $[12] = t10;
    $[13] = t9;
  } else {
    t10 = $[12];
    t9 = $[13];
  }
  useEffect(t9, t10);
  let t11;
  if ($[14] !== onSelect) {
    t11 = option_1 => {
      setSelected(option_1);
      onSelect(option_1);
      setIsOpen(false);
      setSearchTerm("");
    };
    $[14] = onSelect;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  const handleSelect = t11;
  let t12;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = e => {
      setSearchTerm(e.target.value);
    };
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  const handleSearchChange = t12;
  let t13;
  if ($[17] !== width) {
    t13 = width ? {
      width
    } : undefined;
    $[17] = width;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== disabled) {
    t14 = () => !disabled && setIsOpen(_temp);
    $[19] = disabled;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  const t15 = `flex w-full items-center justify-between rounded-md border border-ds-border-standard text-left transition-colors duration-200 ${sm ? "px-3 py-1.5 text-xs" : "px-4 py-2"} ${!disabled ? "bg-background-light text-textPrimary hover:bg-background-light" : "bg-background-secondary text-textSecondary"}`;
  const t16 = selected ? selected.label : placeholder;
  let t17;
  if ($[21] !== isOpen || $[22] !== sm) {
    t17 = isOpen ? <ChevronUpIcon className={sm ? "size-4" : "size-6"} /> : <ChevronDownIcon className={sm ? "size-4" : "size-6"} />;
    $[21] = isOpen;
    $[22] = sm;
    $[23] = t17;
  } else {
    t17 = $[23];
  }
  let t18;
  if ($[24] !== t14 || $[25] !== t15 || $[26] !== t16 || $[27] !== t17) {
    t18 = <button onClick={t14} className={t15}>{t16}{" "}{t17}</button>;
    $[24] = t14;
    $[25] = t15;
    $[26] = t16;
    $[27] = t17;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  let t19;
  if ($[29] !== filteredOptions || $[30] !== handleSelect || $[31] !== isOpen || $[32] !== isSearch || $[33] !== placeholder || $[34] !== searchTerm || $[35] !== selected?.value || $[36] !== sm) {
    t19 = isOpen && <div className={`absolute z-10 mt-1 w-full rounded-lg border border-ds-border-standard bg-background-primary shadow-lg ${sm ? "text-xs" : ""}`}>{isSearch && <div className={`flex items-center border-b border-ds-border-standard bg-background-secondary ${sm ? "px-2 py-1.5" : "px-3 py-2"}`}><SearchIcon className={sm ? "size-3.5 text-textSecondary" : "size-5 text-textSecondary"} /><input type="text" value={searchTerm} onChange={handleSearchChange} placeholder="Search..." className={`w-full border-none bg-background-secondary p-1 text-textPrimary focus:outline-none ${sm ? "text-xs" : ""}`} onClick={_temp2} autoFocus={true} /></div>}<ul className="max-h-48 overflow-x-hidden overflow-y-scroll"><li className={`flex cursor-pointer items-center justify-between text-textSecondary hover:bg-background-light ${sm ? "px-3 py-1.5" : "px-4 py-2"}`} onClick={() => handleSelect(null)}><span>{placeholder}</span></li>{filteredOptions.map(option_2 => <li key={option_2.value} className={`flex cursor-pointer items-center justify-between text-textPrimary hover:bg-background-light ${sm ? "px-3 py-1.5" : "px-4 py-2"}`} onClick={() => handleSelect(option_2)}><span>{option_2.label}</span>{selected?.value === option_2.value && <CheckIcon className={sm ? "size-3.5 text-primary" : "size-6 text-primary"} />}</li>)}{filteredOptions.length === 0 && <li className={`text-textSecondary ${sm ? "px-3 py-1.5" : "px-4 py-2"}`}>No results found</li>}</ul></div>;
    $[29] = filteredOptions;
    $[30] = handleSelect;
    $[31] = isOpen;
    $[32] = isSearch;
    $[33] = placeholder;
    $[34] = searchTerm;
    $[35] = selected?.value;
    $[36] = sm;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  let t20;
  if ($[38] !== t13 || $[39] !== t18 || $[40] !== t19) {
    t20 = <div className="relative w-full" style={t13}>{t18}{t19}</div>;
    $[38] = t13;
    $[39] = t18;
    $[40] = t19;
    $[41] = t20;
  } else {
    t20 = $[41];
  }
  return t20;
};
export default Dropdown;
function _temp(prev) {
  return !prev;
}
function _temp2(e_0) {
  return e_0.stopPropagation();
}